@if (addressesDataSource.data.length > 0 || isLoadingAddresses) {
  <section class="mb1 flex flex-col">
    <div class="flex flex-row justify-start content-center items-center w-full gap-[2rem]">
      <div>
        <!-- Template input-->
        <ng-content></ng-content>
      </div>
    </div>
    <div class="flex flex-row">
      <div class="basis-full">
        <mat-table [dataSource]="addressesDataSource">
          <ng-container matColumnDef="checked">
            <mat-header-cell *matHeaderCellDef="" class="grow-0 shrink-0 basis-[75px]">
              <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="isAllSelected()">
              </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let row" [class.align-top]="row.additionalAddresses.length > 0" class="grow-0 shrink-0 basis-[75px]">
              <div style="vertical-align: top!important;">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? addressRowClick(row) : null" [checked]="row.selected"></mat-checkbox>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef="" class="basis-3/5">
              <span translate="">Address</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let row;" [class.align-top]="row.additionalAddresses.length > 0" [class.pt1]="row.additionalAddresses.length > 0" class="basis-3/5">
              <div class="flex flex-col">
                <div class="flex flex-row justify-start content-center items-center w-full">
                  <div>{{ row.name }}</div>
                  @if (row.additionalAddresses.length > 0) {
                    <div class="ml1">(<span (click)="unlinkCombination(row, $event)" class="underline pointer" translate="">split</span>)</div>
                  }
                </div>
                @for (address of row.additionalAddresses; track address) {
                  <div>
                    - {{ address.addressLine1 }}, {{address.city}}
                  </div>
                }
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="chips">
            <mat-header-cell *matHeaderCellDef="" class="ml1 basis-[30%]">
            </mat-header-cell>
            <mat-cell *matCellDef="let row;" class="ml1 basis-[30%]" [class.align-top]="row.additionalAddresses.length > 0">
              @if (!row.owned) {
                <span class="green" translate="">new purchase</span>
              }
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="addressesDisplayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: addressesDisplayedColumns;"></mat-row>
        </mat-table>
        @if (isLoadingAddresses === true) {
          <div class="loader mt1">
            <mat-spinner diameter="32"></mat-spinner>
          </div>
        }
      </div>
    </div>
  </section>
}